
import fetch from '../../../fetch';
import React from 'react';

import utils from '../../../../utils';

import {Modal, message} from 'antd';
import {ky_constant} from '../../../../viewport/scientificResearch/Constant'
import explicate from '../../../../viewport/scientificResearch/Explicate';
import reqwest from 'reqwest';
import moment from 'moment';
const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号',width: 50},
    {key:'name', label: '申请计划名称',width: 250},
    {key:'projectTypeName', label: '项目分类', width: 150},
    { key: 'beginDate', label: '申请开始日期', width: 150, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    { key: 'endDate', label: '申请结束日期', width: 150, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    {
        key: 'applyState', label: '申请状态', width: 150, render: (d) => explicate.getApplyState(d)
    
    },
]);

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('ky/project/apply/getProjectInfoById/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('ky/project/apply/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.refresh();
                        DataGrid.selections = [];
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'sysparam'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}


const declareProject = (data) => {

	const formData = new FormData();

	formData.append('projectBase', JSON.stringify(data.baseData))

	data.filesData.forEach(file => {
		formData.append('projectFiles', file);
	});

    data.applyFileData.forEach(file => {
		formData.append('mainFile', file);
	});


	return reqwest({
		url: fetch.base + 'ky/project/apply/insertInfo',
		method: 'post',
		processData: false,
		data: formData,
		crossOrigin: true, 
		withCredentials: true,
		success: (response) => {

			var data = JSON.parse(response);

			if(data.code === 200) {
				Modal.success({
					title: '新增申报批次成功！',
					content: data.message,
					onOk:() => {
					}
				});
			} else if (data.code === 201) {
				return response
			}
			else {
				Modal.error({
					title: '新增申报批次失败！',
					content: data.message,
					onOk:() => {
					}
				});
			}
		},
	});
}


export default {
    querySearchById,
    querySearch,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    declareProject
}